import React from 'react'
import Button from 'gu-ui-kit/Button'
import Dropdown from 'gu-ui-kit/Dropdown'
import DropdownItem from 'gu-ui-kit/Dropdown/Item'
import Icon from 'gu-ui-kit/Icon'
import Popover from 'gu-ui-kit/Popover'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { actionConfirmInterrupt, actionStartTrack } from 'modules/Onboarding/store/actions'
import { ROUTES } from 'constants/routes'
import { selectIsOnboardingRunning } from 'modules/Onboarding/store/selectors'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import PropTypes from 'prop-types'
import drawerFooterPopoverStyles from 'components/Drawer/subcomponents/DrawerFooter/drawer-footer-popover.module.scss'
import { useDrawerFooterMenuInteractions } from 'components/Drawer/subcomponents/DrawerFooter/drawer-footer-popover'
import clsx from 'clsx'
import DrawerFooterAnimatedIcon from 'components/Drawer/subcomponents/DrawerFooter/subcomponents/DrawerFooterAnimatedIcon'

const FaqMenu = ({ className, collapse = false, footerAnchorRef = null }) => {
  const { isPopoverViewport, popoverState, triggerBindings, popoverBindings, contentHoverHandlers } =
    useDrawerFooterMenuInteractions({
      collapse,
      footerAnchorRef,
      id: 'faqMenuDropdown',
    })
  const dispatch = useDispatch()
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation(['onboarding', 'common'])
  const isOnboardingRunning = useSelector(selectIsOnboardingRunning)

  const menuItems = (
    <>
      <DropdownItem
        component={'button'}
        size={'m'}
        startIcon={
          <Icon
            name={'question'}
            width={20}
          />
        }
        type={'button'}
        onClick={() => {
          popoverState.close()
          window.open(pathGen(ROUTES.FAQ), '_blank', 'noopener,noreferrer')
        }}
      >
        {t('common::user_menu.help')}
      </DropdownItem>

      <DropdownItem
        component={'button'}
        size={'m'}
        startIcon={
          <Icon
            name={'learning'}
            width={20}
          />
        }
        type={'button'}
        onClick={() => {
          popoverState.close()
          if (isOnboardingRunning) {
            dispatch(actionConfirmInterrupt())
          } else {
            dispatch(actionStartTrack('welcome'))
          }
        }}
      >
        {isOnboardingRunning
          ? t('onboarding::menu.finish_learning')
          : t('onboarding::menu.start_learning')}
      </DropdownItem>
    </>
  )

  return (
    <>
      <Button
        {...triggerBindings}
        grey
        noLabel
        className={className}
        size={'s'}
        startIcon={<DrawerFooterAnimatedIcon name={'question'} />}
        title={t('common::user_menu.help_menu_toggle')}
        variant={'ghost'}
      />
      <Popover
        className={
          isPopoverViewport
            ? clsx(drawerFooterPopoverStyles['popover'], drawerFooterPopoverStyles['popover_faq'], {
                [drawerFooterPopoverStyles['popover_collapsed']]: collapse,
              })
            : undefined
        }
        {...popoverBindings}
        bodyClassName={clsx({
          [drawerFooterPopoverStyles['body_expanded']]: isPopoverViewport && !collapse,
          [drawerFooterPopoverStyles['body_collapsed']]: isPopoverViewport && collapse,
        })}
      >
        {isPopoverViewport ? (
          <div
            className={clsx(drawerFooterPopoverStyles['faq-menu'], {
              [drawerFooterPopoverStyles['faq-menu_collapsed']]: collapse,
              [drawerFooterPopoverStyles['faq-menu_expanded']]: !collapse,
            })}
            {...contentHoverHandlers}
          >
            {menuItems}
          </div>
        ) : (
          <Dropdown
            className={clsx(
              drawerFooterPopoverStyles['faq-menu'],
              drawerFooterPopoverStyles['faq-menu_bottomSheet'],
            )}
            {...contentHoverHandlers}
          >
            {menuItems}
          </Dropdown>
        )}
      </Popover>
    </>
  )
}

export default FaqMenu

FaqMenu.propTypes = {
  className: PropTypes.string,
  collapse: PropTypes.bool,
  footerAnchorRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
}
